// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { OpticalDeviceLensMeasurementResponse } from './optical-device-lens-measurement-response';

/** See com.rev360.pms.api.controller.order.devicemeasurement.OpticalDeviceMeasurementResponse */
/* istanbul ignore next */
@GandalfModel
export class OpticalDeviceMeasurementResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Date })
	deviceLogDate!: Date;

	@GandalfProperty({ designType: Number })
	deviceMeasurementId!: number;

	@GandalfProperty({ designType: String })
	jobIdentifier!: string | null;

	@GandalfProperty({ designType: OpticalDeviceLensMeasurementResponse })
	odLensMeasurements!: OpticalDeviceLensMeasurementResponse;

	@GandalfProperty({ designType: OpticalDeviceLensMeasurementResponse })
	osLensMeasurements!: OpticalDeviceLensMeasurementResponse;

	@GandalfProperty({ designType: Number })
	pantoscopicTilt!: number | null;

	@GandalfProperty({ designType: Number })
	wrapAngle!: number | null;

}
